import { usePopperTooltip } from 'react-popper-tooltip';
import type { IPopperTooltip } from '../../types/popper_tooltip';
import styles from "./popper-tooltip.module.scss";

export const PopperTooltip = ({
  children,
  text,
  hintText,
  triggerOn = 'hover',
  placement = 'auto'
}: IPopperTooltip) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip(
    {
      placement,
      trigger: triggerOn
    }
  );
  return (
    <>
      <div
        className={styles["popper-tooltip__trigger"]}
        ref={setTriggerRef}
      >
        {children}
      </div>

      {
        ((text || hintText) && visible) &&
        <>
          <div
            {...getTooltipProps({ className: styles["popper-tooltip__tooltip"] })}
            ref={setTooltipRef}
          >
            <div {...getArrowProps({ className: styles["popper-tooltip__tooltip__arrow"] })} />
            {text && <div className={styles["popper-tooltip__tooltip__text"]}>{text}</div>}
            {hintText && <div className={styles["popper-tooltip__tooltip__hint-text"]}>{hintText}</div>}
          </div>
        </>
      }
    </>
  )
}
